<template>
  <el-drawer
    class="drawer"
    :class="customClass"
    :visible.sync="isOpen"
    :with-header="false"
    :show-close="showClose"
    :modal="true"
    :wrapper-closable="wrapperClosable"
    :direction="direction"
    :size="size"
    @closed="close"
  >
    <template v-if="component">
      <component :is="component" :meta="meta"></component>
    </template>
  </el-drawer>
</template>
<script>
import Vue from 'vue'
import { Drawer } from 'element-ui'
Vue.use(Drawer)

export default {
  props: {
    component: {
      type: Object,
      required: true,
    },
    size: {
      type: String,
      default: '600px',
    },
    customClass: {
      type: String,
      default: '',
    },
    direction: {
      type: String,
      default: 'rtl',
    },
    wrapperClosable: {
      type: Boolean,
      default: false,
    },
    showClose: {
      type: Boolean,
      default: false,
    },
    meta: {
      type: null,
      default: null,
    },
  },
  data() {
    return {
      isOpen: false,
    }
  },
  watch: {
    isOpen(val) {
      if (val) {
        document.body.classList.add('overflow-hidden')
        this.$emit('drawer:open', { event: 'drawer:open', value: this.isOpen })
      } else {
        document.body.classList.remove('overflow-hidden')
      }
    },
  },
  mounted() {
    setTimeout(() => {
      this.isOpen = true
    }, 0)
  },
  methods: {
    close() {
      this.$emit('drawer:close', { event: 'drawer:close', value: this.isOpen })
      this.$Drawer.destroy()
    },
  },
}
</script>
<style lang="scss">
.drawer {
  .el-drawer {
    padding: 24px;
    top: 55px;
    height: calc(100% - 55px);
  }
  .el-drawer.rtl {
    border-top-left-radius: 12px;
    border-bottom-left-radius: 12px;
  }
  &--half-size {
    .el-drawer {
      width: 100%;
      max-width: 980px;
    }
    .el-drawer.rtl {
      @screen -xl {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
      }
    }
  }
}
</style>
